import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
@Injectable()
export class HttpCustomInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private translateService: TranslateService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let lang = this.translateService.currentLang;
    if (lang == 'en') {
      lang = 'en-CA';
    } else if (lang == 'fr') {
      lang = 'fr-CA';
    }

    let token = localStorage.getItem('token') //this.authService.getUser()
      ? localStorage.getItem('token')
      :  this.authService.getUser()?.token;

    // if (!token) {
    //   token = localStorage.getItem('token');
    // }


    if (!request.url.includes('donor/transaction/save')){ // /keep token in in case of save trnsaction call
      if (token && this.tokenExpired(token)){
        token = null;
      }
    }


    // provider and login api checks are added here because if there is an api failure 401,
    // the user is directed to login page and the user state is not cleared and the user token still exists,
    // but is expired which fails the login api call.
    if (!request.url.includes('assets') && !request.url.includes('provider') && !request.url.includes('login')) {
      // Clone headers to preserve existing ones (like X-Recaptcha-Token)
      let headers = request.headers;

      if (token) {
        headers = headers.set('Authorization', 'bearer ' + token);
      }

      const timestamp = Date.now();
      let urlWithTimestamp = '';
      if (request.url.includes('?')) {
        //add timestamp on url for avoiding caching
        urlWithTimestamp = `${request.url}&${timestamp}&lang=${lang}`;
      } else {
        urlWithTimestamp = `${request.url}?${timestamp}&lang=${lang}`;
      }

      request = request.clone({
        headers: headers,
        url: urlWithTimestamp,
        withCredentials: true // Include cookies with all API requests
      });
    } else {
      // Even for asset requests, include credentials if they are API calls
      if (!request.url.includes('assets')) {
        request = request.clone({
          withCredentials: true
        });
      }
    }

    return next.handle(request);
  }

  private tokenExpired(token: string) {
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    return (Math.floor((new Date).getTime() / 1000)) >= expiry;
  }


}
